<template>
  <h1 v-if="opcionSeleccionada == 'Notarios'" class="titulo-grafica">
    Notarios públicos que validaron la creación de empresas fantasma
  </h1>
  <h1 v-if="opcionSeleccionada == 'Sanciones'" class="titulo-grafica">
    Sanciones e inhabilitaciones de notarios públicos
  </h1>
  <div class="controles-mapa">
    <p v-if="opcionSeleccionada == 'Notarios'">
      Coloca el cursor sobre la entidad para conocer el número de notarios
      públicos vinculados a empresas fantasma en cada Estado.
    </p>
    <p v-if="opcionSeleccionada == 'Sanciones'">
      Coloca el cursor sobre la entidad para conocer el número de sanciones y/o
      inhabilitaciones aplicadas entre 2020 y 2024
    </p>
    <select v-model="opcionSeleccionada">
      <option>Notarios</option>
      <option>Sanciones</option>
    </select>
  </div>
  <div id="contenedor_mapa-b">
    <div id="tooltip" class="tultip">
      <p v-if="opcionSeleccionada == 'Notarios'">
        <span class="titulo-highlight">
          {{ entidad_mapa }}
        </span>
        <br />
        Notarios: <span class="highlight"> {{ notarios_mapa }} </span> <br />
        Empresas: <span class="highlight"> {{ empresas_mapa }}</span> <br />
      </p>
      <p v-if="opcionSeleccionada == 'Sanciones'">
        <span class="titulo-highlight">
          {{ entidad_mapa }}
        </span>
        <br />
        Sanciones: <span class="highlight"> {{ sanciones_mapa }}</span> <br />
        Revocaciones: <span class="highlight"> {{ revocaciones_mapa }}</span>
        <br />
        Total: <span class="highlight"> {{ total_sanciones }}</span>
      </p>
    </div>
    <svg
      id="mapa-b"
      :width="ancho + margenes.derecha + margenes.izquierda"
      :height="alto_svg"
    >
      <g
        class="grupo-poligonos-b"
        :transform="`translate(${margenes.izquierda}, ${margenes.arriba})`"
      ></g>
      <g
        class="eje-X"
        :transform="`translate(${margenes.izquierda + ancho / 4}, ${
          alto_svg - margenes.arriba - 17
        })`"
      ></g>
      <g
        class="choropleth-legend"
        :transform="`translate(${margenes.izquierda + ancho / 4}, ${
          alto_svg - margenes.arriba - 30
        } )`"
      ></g>
    </svg>
  </div>
</template>

<script setup>
import * as d3 from "d3";
import { onMounted, ref, onUnmounted, watch } from "vue";
import datos_geograficos from "@/assets/data/estados-protocolos.json";

const geodata = ref(datos_geograficos);

const contenedor_svg = ref();
const svg = ref();
const grupo_poligonos = ref();
const paths = ref();
const ancho = ref(0);
const alto_svg = ref();
const alto = ref(0);
const margenes = ref({
  derecha: 20,
  izquierda: 20,
  abajo: 80,
  arriba: 20,
});

const proyeccion = ref();
const geoGenerator = ref();

const maxNotarios = ref(95);
const color_scale = ref();
const color_inicio = ref("#FFFFFF");
const color_notarios = ref("#B70101");
const color_sanciones = ref("#38009F");
const color_final = ref();
const coropleth_legend = ref();
const defs = ref();
const linearGradientNotarios = ref();
const linearGradientSanciones = ref();
const eje_X = ref();
const escala_X = ref();

const el_tooltip = ref();
const entidad_mapa = ref();
const notarios_mapa = ref();
const empresas_mapa = ref();
const total_sanciones = ref();
const sanciones_mapa = ref();
const revocaciones_mapa = ref();

const opcionSeleccionada = ref("Notarios");
onMounted(() => {
  contenedor_svg.value = document.getElementById("contenedor_mapa-b");
  svg.value = d3.select("svg#mapa-b");
  grupo_poligonos.value = d3.select("g.grupo-poligonos-b");
  coropleth_legend.value = d3.select("g.choropleth-legend");
  eje_X.value = d3.select("g.eje-X");
  el_tooltip.value = d3.select("div#tooltip").style("visibility", "hidden");

  generaEscalas();
  creaPoligonos();
  dibujaPoligonos();
  dibujaEscala();

  window.addEventListener("resize", reescalanding);
});
onUnmounted(() => {
  window.removeEventListener("resize", reescalanding);
});
watch(opcionSeleccionada, () => {
  generaEscalas();
  dibujaPoligonos();
  dibujaEscala();
});

function reescalanding() {
  generaEscalas();
  dibujaPoligonos();
  dibujaEscala();
}

function generaEscalas() {
  ancho.value =
    contenedor_svg.value.clientWidth -
    margenes.value.derecha -
    margenes.value.izquierda;

  //alto.value = alto_svg.value - margenes.value.arriba - margenes.value.abajo;
  alto.value = ancho.value * 0.5;
  alto_svg.value = alto.value + margenes.value.arriba + margenes.value.abajo;

  if (opcionSeleccionada.value == "Notarios") {
    color_final.value = color_notarios.value;
  } else {
    color_final.value = color_sanciones.value;
  }

  color_scale.value = d3
    .scaleLinear()
    .domain([0, maxNotarios.value])
    .range([color_inicio.value, color_final.value]);

  escala_X.value = d3
    .scaleLinear()
    .domain([0, maxNotarios.value])
    .range([0, ancho.value / 2]);
  eje_X.value.call(d3.axisBottom(escala_X.value));
  eje_X.value.selectAll("path,line").remove();

  // Definimos la proyección que vamos a usar para el mapa
  proyeccion.value = d3
    .geoMercator()
    .scale(1.5 * ancho.value)
    .center([-102, 24]) // El centro de mx aprox
    .translate([0.5 * ancho.value, 0.5 * alto.value]);

  // Le decimos cómo vamos a crear los paths para el mapa
  geoGenerator.value = d3.geoPath().projection(proyeccion.value);
}

function creaPoligonos() {
  paths.value = grupo_poligonos.value
    .selectAll("path")
    .data(geodata.value.features)
    .enter()
    .append("path")
    .attr("class", "entidad");
}

function dibujaPoligonos() {
  paths.value
    .attr("d", geoGenerator.value)
    .attr("fill", (d) => {
      if (opcionSeleccionada.value == "Notarios") {
        return color_scale.value(d.properties.notarios_reincidentes);
      } else {
        if (d.properties.no_sanciones == "No disponible") {
          /* return "#2D2624"; */
          return "#EBEBEB";
        } else {
          return color_scale.value(d.properties.no_sanciones);
        }
      }
    })
    .attr("stroke", "#DDDDDD" /*"#1f1a19" */)
    .attr("opacity", 1)
    .on("mouseover", abrirTooltip)
    .on("mouseleave", cerrarTooltip)
    .on("mousemove", ajustarPosicionTooltip);
}

function dibujaEscala() {
  defs.value = coropleth_legend.value.append("defs");

  // Ahora para la barra azul
  linearGradientSanciones.value = defs.value
    .append("linearGradient")
    .attr("id", "linear-gradient-sanciones")
    .attr("x1", "0%")
    .attr("y1", "0%")
    .attr("x2", "100%")
    .attr("y2", "0%");

  //Set the color for the start (0%)
  linearGradientSanciones.value
    .append("stop")
    .attr("offset", "0%")
    .attr("stop-color", color_inicio.value);

  //Set the color for the end (100%)
  linearGradientSanciones.value
    .append("stop")
    .attr("offset", "100%")
    .attr("stop-color", color_sanciones.value);

  // Primero para la barra de notarios
  linearGradientNotarios.value = defs.value
    .append("linearGradient")
    .attr("id", "linear-gradient-notarios")
    .attr("x1", "0%")
    .attr("y1", "0%")
    .attr("x2", "100%")
    .attr("y2", "0%");

  //Set the color for the start (0%)
  linearGradientNotarios.value
    .append("stop")
    .attr("offset", "0%")
    .attr("stop-color", color_inicio.value);

  //Set the color for the end (100%)
  linearGradientNotarios.value
    .append("stop")
    .attr("offset", "100%")
    .attr("stop-color", color_notarios.value);

  coropleth_legend.value
    .selectAll("rect")
    .data([{}])
    .join(
      (enter) => {
        enter
          .append("rect")
          .attr("width", ancho.value / 2)
          .attr("height", 20)
          .style("fill", () => {
            if (opcionSeleccionada.value == "Notarios") {
              return "url(#linear-gradient-notarios)";
            } else {
              return "url(#linear-gradient-sanciones)";
            }
          });
      },
      (update) => {
        update
          .attr("width", ancho.value / 2)
          .attr("height", 20)
          .style("fill", () => {
            if (opcionSeleccionada.value == "Notarios") {
              return "url(#linear-gradient-notarios)";
            } else {
              return "url(#linear-gradient-sanciones)";
            }
          });
      },
      (exit) => {
        exit.remove();
      }
    );
}

var abrirTooltip = function () {
  entidad_mapa.value = d3.select(this).datum()["properties"]["entidad"];
  notarios_mapa.value = d3.select(this).datum()["properties"][
    "notarios_reincidentes"
  ];
  empresas_mapa.value = d3.select(this).datum()["properties"]["no_empresas"];
  total_sanciones.value = d3.select(this).datum()["properties"]["no_sanciones"];
  sanciones_mapa.value = d3.select(this).datum()["properties"][
    "tipo_sanciones"
  ]["sanciones"];
  revocaciones_mapa.value = d3.select(this).datum()["properties"][
    "tipo_sanciones"
  ]["revocaciones"];

  el_tooltip.value.style("visibility", "visible").selectAll("text");

  //xconsole.log(entidad, notarios, empresas);
  //console.log(d3.select(this).datum()["properties"]);
};

var cerrarTooltip = function () {
  el_tooltip.value.style("visibility", "hidden");
};

var ajustarPosicionTooltip = function () {
  //console.log(d3.pointer(event, document.body));
  let position = d3.pointer(event, document.body);
  let width = window.innerWidth;
  if (position[0] + 200 > width) {
    el_tooltip.value
      .style("left", position[0] - 165 + "px")
      .style("top", position[1] + 40 + "px");
  } else {
    el_tooltip.value
      .style("left", position[0] + 20 + "px")
      .style("top", position[1] + 40 + "px");
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.highlight {
  font-weight: bold;
}
.titulo-highlight {
  font-size: 18px;
  font-weight: bolder;
}
.contenedor-propuestas {
  display: flex;
}
.propuestas {
  width: 45%;
}
.municipios {
  width: 45%;
}
.tultip {
  position: absolute;
  z-index: 2;
  text-align: left;
  background-color: #252323;
  color: white;
  opacity: 0.93;
  height: auto;
  width: 150px;
  font-size: 15px;
  padding: 5px;
  padding-left: 10px;
}
</style>
